
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkBudgetAccountTypeEnum } from '../models/work-budget-account-type-enum';
import { WorkBudgetIstSourceEnum } from '../models/work-budget-ist-source-enum';
import { WorkBudgetSollSourceEnum } from '../models/work-budget-soll-source-enum';

export function getUpdateBudgetAccountDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    accountType: new FormControl<WorkBudgetAccountTypeEnum | undefined>(undefined),
    istSource: new FormControl<WorkBudgetIstSourceEnum | undefined>(undefined),
    sollSource: new FormControl<WorkBudgetSollSourceEnum | undefined>(undefined),
    sortableRank: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(undefined),
    isAdditive: new FormControl<boolean | undefined>(undefined),
})
;
}
      